

























import { PropType, ref, defineComponent } from "@vue/composition-api";
import { LiveChatInvitation } from "@scrile/api-provider/dist/api/LiveChatInvitationsProvider";
import AvatarDescription from "@/components/AvatarDescription";
import BaseCheckbox from "@/components/BaseCheckbox";
import ListItem from "@/components/ListItem";

export default defineComponent({
  name: "BroadcastingCreatorItem",
  components: { AvatarDescription, BaseCheckbox, ListItem },
  props: {
    invitation: { type: Object as PropType<LiveChatInvitation>, required: true },
    userAmount: { type: Number, required: true },
    isModerator: { type: Boolean, required: true },
    processing: { type: Boolean },
  },
  setup(_, { emit }) {
    const loading = ref(false);
    const onUpdateModerator = (userId: string) => {
      loading.value = true;
      emit("updateModerator", userId, () => {
        loading.value = false;
      });
    };

    return { loading, onUpdateModerator };
  },
});
